// Notifications only: never put credentials, responses or authentication tokens here.
const listeners = new Set()

export function onIntegrationIdentityInvalidated(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function invalidateIntegrationIdentity() {
  listeners.forEach(listener => listener())
}

// USER JWT already has exp (JoseJwtTokenUtil). Decode only a UI cleanup deadline;
// this does not verify a token or grant permission. Retain no token/payload.
export function integrationIdentityExpiresAt(token) {
  try {
    if (typeof token !== 'string' || typeof atob !== 'function') return null
    const payload = token.trim().split('.')[1]
    if (!payload) return null
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const claims = JSON.parse(atob(base64 + '='.repeat((4 - base64.length % 4) % 4)))
    return typeof claims.exp === 'number' && Number.isFinite(claims.exp) && claims.exp > 0 ? claims.exp * 1000 : null
  } catch (error) { return null }
}



// WEBPACK FOOTER //
// ./src/utils/integrationClientSession.js